import React from 'react'
import { connect } from 'react-redux'
import { Segment, Card, Image } from 'semantic-ui-react'
import RequestMenu from '../components/RequestMenu'
import ImageCarousel from '../components/ImageCarousel'
import Survey from '../components/Survey'
import Diagnosis from './Diagnosis'

const items = [
    'Information',
    'Pictures',
    'Survey',
    'Diagnosis'
]

const infoImage = {
    houseplant: 'https://firebasestorage.googleapis.com/v0/b/plant-hospital.appspot.com/o/config%2Fhouseplant.jpg?alt=media&token=1dd7a9e7-2d41-49a2-bb65-bae7fef46c8f',
    landscape: 'https://firebasestorage.googleapis.com/v0/b/plant-hospital.appspot.com/o/config%2Flandscape.jpg?alt=media&token=4f1f0526-8604-4155-9165-98d3a0f8fd0c',
    lawn: 'https://firebasestorage.googleapis.com/v0/b/plant-hospital.appspot.com/o/config%2Flawn.jpg?alt=media&token=4c5ebf8f-af53-4f51-9239-20a22e5a553a'
}



class RequestDetail extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            scene: 0
        }
    }

    onClick = (scene) => {
        this.setState({ scene })
    }

    renderInfo = () => {
        //console.log("current request: ", this.props.admin.currentRequest)
        
        const { requestArray, currentIndex } = this.props.requestList
        const { id, data } = requestArray[currentIndex]
        const { email, plantType, date_created } = data
        const date = new Date(date_created).toLocaleDateString()

        return (
            <div>
                <Card>
                    <Image src={infoImage[plantType]} style={{width: '100%', height: 200, resizeMode: 'stretch'}} /> 
                    <Card.Content>
                        <Card.Header>{email}</Card.Header>
                        <Card.Meta>
                            created on <span className='date'>{date}</span>
                        </Card.Meta>
                        {/* <Card.Description>
                            Matthew is a musician living in Nashville.
                        </Card.Description> */}
                    </Card.Content>
                    <Card.Content extra>
                    <Card.Header>{plantType}</Card.Header>
                        ref: {id}
                    </Card.Content>
                    
                </Card>
                
            </div>
        )
    }

    renderPictures = () => {
        // const { images } = this.props.admin.currentRequest.data
        const { requestArray, currentIndex } = this.props.requestList
        const { images } = requestArray[currentIndex].data
        //console.log("images: ", images)

        if (images === null) {
            return "There are no pictures"
        }


        return <ImageCarousel images={images} />
    }

    renderSurvey = () => {
        // const { survey } = this.props.admin.currentRequest.data
        const { requestArray, currentIndex } = this.props.requestList
        const { survey } = requestArray[currentIndex].data
        //console.log("survey: ", survey)

        if (survey === null) {
            return "There are no questions"
        }


        return <Survey survey={survey} />
    }

    renderDiagnosis = () => {
        return <Diagnosis />
    }
    

    render() {
        // console.log("reqeust: ", this.props.request)
        // const { request } = this.props
        const { scene } = this.state
        let array = items.map((item, index) => {
            return ({
                name: item,
                onClick: this.onClick
            })
        })

        let currentScene
        switch (scene) {
            case 0:
                currentScene = this.renderInfo()
                break
            case 1:
                currentScene = this.renderPictures()
                break
            case 2:
                currentScene = this.renderSurvey()
                break
            case 3:
                currentScene = this.renderDiagnosis()
                break
            default:
                break
        }

        return (
            <div>
                <RequestMenu items={array} active={scene} />
                <Segment style={{flex: 1, height: '100'}}>
                    {currentScene}
                </Segment>
            </div>
        )
    }
}

const mapStateToProps = state => {
    //console.log("req detail: ", state.admin)
    const { admin, requestList } = state
    return { admin, requestList }
}

export default connect(mapStateToProps, null)(RequestDetail)